<template>
  <div>
    <div class="card-body">
      <table class="table table-sm table-bordered">
        <thead class="bg-custom">
          <tr>
            <th>DOCUMENTTYPE</th>
            <th>NAME</th>
            <th>DATA</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="doc in documents" :key="doc.KYC_ATTACHMENT_ID">
            <td>{{ doc.Type }}</td>
            <td>{{ doc.AT_NAME }}</td>
            <td>
              <img :src="doc.AT_DATA" class="form-control" style="height:50px;width:50px" @click="newTabImage(doc)" />
            </td>
            <td>
              <button class="btn btn-primary btn-sm" @click="editAttachment(doc)"><i class="fas fa-pencil-alt" /></button>
              <a :href="doc.AT_DATA" :download="doc.AT_DATA" target="_blank" class="btn btn-secondary btn-sm"><i class="fa fa-download" aria-hidden="true" /></a>
              <button class="btn btn-danger btn-sm" @click="deleteAttachment(doc)">
                <i class="fa fa-trash" />
              </button>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td colspan="9">
              <button class="btn btn-primary btn-sm btn-block" @click="openModal()">Add New</button>
            </td>
          </tr>
        </tfoot>
      </table>

      <div class="modal fade show" data-backdrop="static" id="edu" aria-modal="true" role="dialog">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header bg-custom">
              <h4 class="modal-title">{{ isEditing ? 'Edit Document Detail' : 'Add Document Detail' }}</h4>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true" style="color:white">×</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="form-group">
                <label>Document Type</label>
                <v-select v-model="newDoc.AT_ID" :reduce="x=>x.AT_ID" :options="attachmentTypes" label="AT_DESC" placeholder="Select Document Type" @input="updateFileSizeMessage"></v-select>
              </div>
              <div class="form-group">
                <label>Name</label>
                <input v-model="newDoc.AT_Name" class="form-control" placeholder="Enter Name">
              </div>
              <div class="form-group">
                <label>Data</label>
                <input type="file" id="attachment" @change="onFileUpload" class="form-control" accept=".jpg,.jpeg,.png,.pdf">
                <div v-if="newDoc.AT_DATA" class="mt-2">Preview: <img :src="newDoc.AT_DATA" style="max-width: 100px;"></div>
              </div>
              <div v-if="fileSizeMessage" style="color:red">{{ fileSizeMessage }}</div>
            </div>
            <div class="modal-footer justify-content-between">
              <button type="button" class="btn btn-success" @click="saveDocument()">{{ isEditing ? 'Update' : 'Save changes' }}</button>
              <button type="button" class="btn btn-danger" data-dismiss="modal">Close</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card-footer">
      <button class="btn btn-sm btn-success float-right" v-on:click="save">Save</button>
    </div>
  </div>
</template>

<script>
  import axios from 'axios';

  export default {
    props: {
      clientid: Number,
    },
    data() {
      return {
        showModal: false,
        documents: [],
        deletedIds: [],
        attachmentTypes: [],
        newDoc: { AT_ID: 0, AT_Name: '', AT_DATA: '', BP_ID: this.clientid, KYC_ATTACHMENT_ID: 0 },
        fileSizeMessage: '',
        isEditing: false,
        editingIndex: null,
        fileSize: 0,
      };
    },
    created() {
      this.pageLoad();
    },
    methods: {
      pageLoad() {
        var vm = this;
        axios.get("/api/UICApi/pageLoadAttachments?ID=" + this.clientid)
          .then(function (res) {
            vm.attachmentTypes = res.data.types;
            vm.documents = res.data.attachment;
          })
          .catch((error) => {
            console.log(error);
            toastr.error("Failed to load document types.");
          });
      },
      editAttachment(doc) {
        this.isEditing = true;
        this.editingIndex = this.documents.findIndex(d => d.KYC_ATTACHMENT_ID === doc.KYC_ATTACHMENT_ID);
        this.newDoc = {
          AT_ID: doc.AT_ID,
          AT_Name: doc.AT_NAME,
          AT_DATA: doc.AT_DATA,
          BP_ID: doc.BP_ID,
          KYC_ATTACHMENT_ID: doc.KYC_ATTACHMENT_ID,
          contentType: doc.contentType || 'image/jpeg',
        };
        this.updateFileSizeMessage();
        $("#edu").modal("show");
      },
      deleteAttachment(doc) {

        if (doc.KYC_ATTACHMENT_ID !== 0) {
          this.deletedIds.push(doc.KYC_ATTACHMENT_ID);
        }

        this.documents = this.documents.filter(d => d !== doc);
      },
      updateFileSizeMessage() {
        const selectedType = this.attachmentTypes.find(x => x.AT_ID == this.newDoc.AT_ID);
        this.fileSize = selectedType.AT_SIZE;
        this.fileSizeMessage = "Maximum file size allowed " + this.fileSize + " " + "MB.";
      },
      newTabImage(doc) {
        const link = document.createElement('a');
        link.href = doc.AT_DATA;
        link.target = '_blank';
        link.download = doc.AT_DATA.split('/').pop() || 'image';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      },
      saveDocument() {
        if (!this.newDoc.AT_ID || !this.newDoc.AT_Name || !this.newDoc.AT_DATA) {
          toastr.error("Please fill all fields and upload a valid file.");
          return;
        }
        const docData = {
          AT_ID: this.newDoc.AT_ID,
          AT_NAME: this.newDoc.AT_Name,
          AT_DATA: this.newDoc.AT_DATA,
          Type: this.attachmentTypes.find(x => x.AT_ID == this.newDoc.AT_ID).AT_NAME,
          BP_ID: this.newDoc.BP_ID,
          KYC_ATTACHMENT_ID: this.newDoc.KYC_ATTACHMENT_ID,
          contentType: this.newDoc.contentType,
        };
        if (this.isEditing) {
          this.$set(this.documents, this.editingIndex, docData);
        } else {
          this.documents.push(docData);
        }
        $("#edu").modal("hide");
        this.fileSizeMessage = '';
        this.isEditing = false;
        this.editingIndex = null;
        this.newDoc = { AT_ID: 0, AT_Name: '', AT_DATA: '', BP_ID: this.clientid, KYC_ATTACHMENT_ID: 0 };
      },
      openModal() {
        this.isEditing = false;
        this.editingIndex = null;
        this.newDoc = { AT_ID: 0, AT_Name: '', AT_DATA: '', BP_ID: this.clientid, KYC_ATTACHMENT_ID: 0 };
        this.fileSizeMessage = '';
        $("#edu").modal("show");
      },
      checkFile(file) {
        if (!file) {
          return false;
        }
        var bytes = Number(file.size) * 1000000;
        console.log(file.size);
        if (file.size > Number(bytes)) {
          toastr.error("File size is too large");
          return false;
        }
        if (file.type !== "image/jpeg" && file.type !== "image/png" && file.type !== "application/pdf") {
          toastr.error("Invalid File! Only JPG, PNG, and PDF files are allowed.");
          return false;
        }
        this.newDoc.contentType = file.type;
        return true;
      },
      onFileUpload(event) {
        //toastr.error("Please select Document Type first.");
        const file = event.target.files[0];
        if (this.checkFile(file)) {
          const reader = new FileReader();
          reader.onload = (e) => {
            this.newDoc.AT_DATA = e.target.result;
          };
          reader.readAsDataURL(file);
        } else {
          document.getElementById('attachment').value = '';
        }
      },
      isImage(contentType) {
        return contentType.startsWith('image/');
      },
      save() {
        var vm = this;
        startReq();
        axios.post('/api/UICApi/SaveAttachments', {
          list: vm.documents,
          deletedIds: vm.deletedIds
        })
          .then(response => {
            endReq();
            if (response.data.status) {
              this.deletedIds = [];
              toastr.success(response.data.msg);
            } else {
              toastr.error(response.data.msg);
            }
          })
          .catch(error => {
            endReq();
            vm.error = 'Error saving Attachments';
            console.log(error);
            toastr.error("Failed to save documents.");
          });
      },
    }
  };
</script>



// WEBPACK FOOTER //
// src/components/ims/Attachments.vue